exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#earth_div[data-v-43258602]{background-color:#000}#earth_div[data-v-43258602],.abspos[data-v-43258602]{width:100%;height:100%}.abspos[data-v-43258602]{position:absolute;top:0;left:0;color:#fff;background-color:rgba(56,56,56,.596)}.all-center[data-v-43258602]{text-align:center}.disclaimer[data-v-43258602],.privacy[data-v-43258602]{white-space:pre-wrap}.red[data-v-43258602]{color:red}.linker[data-v-43258602]{color:#a0b1ff;text-decoration:underline}.marginer[data-v-43258602]{margin:0 auto;width:500px;text-align:center}", ""]);

// exports
